module.exports = __webpack_public_path__ + "img/percent-mobile.83ed4139.png";